import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import "./index.css";
import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import './assets/css/styles.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplateBasic from 'react-alert-template-basic';
import App from './App';
import { Provider } from 'react-redux';
import store from './Store';

const initialRedirectPath =
  window.location.pathname + window.location.search + window.location.hash;
const AlertTemplate = (props) => {
  if (props.options?.orderDateAlert) {
    return (
      <div
        className="order-date-alert-toast"
        data-order-date-message={props.message}
      >
        <AlertTemplateBasic {...props} />
      </div>
    );
  }
  return <AlertTemplateBasic {...props} />;
};

const options = {
  position: positions.TOP_RIGHT,
  timeout: 7000,
  offset: '30px',
  transition: transitions.FADE,
  containerStyle: {
    zIndex: 999999999999,
  },
};

const Root = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const buildMobileUrl = () => {
    const baseUrl = process.env.REACT_APP_MOBILE_URL;
    if (!baseUrl) return "";

    const url = new URL(baseUrl);
    const token = localStorage.getItem("token") || "";

    if (token && token !== "undefined") {
      url.searchParams.set("token", token);
    }

    const currentPath =
      window.location.pathname + window.location.search + window.location.hash;

    const redirectPath =
      initialRedirectPath && initialRedirectPath !== "/"
        ? initialRedirectPath
        : currentPath;

    if (redirectPath && redirectPath !== "/") {
      url.searchParams.set("redirect", redirectPath);
    }

    return url.toString();
  };

  const mobileUrl = buildMobileUrl();

  return (
    <AlertProvider template={AlertTemplate} {...options}>
      {isMobile ? (
        <iframe
          key={mobileUrl}
          src={mobileUrl}
          style={{ 
            width: "100vw", 
            height: "100vh", 
            border: "none" 
          }} 
          title="Mobile Toolsvilla Seller"
        />
      ) : (
        <Provider store={store}>  
        <App />
        </Provider>
      )}
    </AlertProvider>
  );
};

ReactDOM.render(<Root />, document.getElementById('root'));
